export default __webpack_public_path__ + "static/media/P11.54c0d8a6.png";